import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import {cssClass} from "../../../../shared";

@Component({
  selector: 'CustomTitle',
  standalone: true,
  imports: [
    CommonModule
  ],
  template: `
    <div class="flex align-items-center">
      <div class="title" [ngClass]="styleClass">{{title}}</div>
    </div>
  `
})
export class CustomTitle {
  @Input() title !: string;
  @Input() showTag ?: boolean = true;
  @Input() styleClass ?: cssClass = 'text-2xl';
}
